import * as React from 'react';
import styled from 'styled-components';

import { Empty, EmptyIcon } from '@creditornot/cb-placeholders';
import { Spinner } from '@creditornot/cb-progress';

import { FilterItems } from './FilterItems';
import { ListItemBase } from './types';
import { ApiErrorNotification } from '../../ApiErrorNotification';
import { SearchInput } from '../../Search/SearchInput';
import { Stack } from '../../Stack';
import { ThinScrollbarContainer } from '../../ThinScrollbarContainer';
import { Typography as T } from '../../Typography/Typography';

const Title = styled(T.captionLabel)`
  display: block;
  margin-bottom: 12px;
`;

const ItemsContainer = styled(ThinScrollbarContainer)`
  margin-top: 12px;
  max-height: 400px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
const SpinnerContainer = styled(Stack)`
  padding: 12px;
`;

const StyledEmpty = styled(Empty)`
  margin-bottom: 12px;
`;

type Props<ListItem extends ListItemBase> = {
  title?: string;
  items: ListItem[];
  filterItems?: string[];
  isLoading: boolean;
  error: Error | null;
  emptyTitle: string;
  searchQuery?: string;
  onSearchQueryChange: (value: string) => void;
  onChange: (items: string[]) => void;
};

export const CountryItemsFilter = <ListItem extends ListItemBase>({
  title,
  items,
  filterItems = [],
  isLoading,
  error,
  searchQuery = '',
  emptyTitle,
  onSearchQueryChange,
  onChange,
}: React.PropsWithChildren<Props<ListItem>>) => {
  return (
    <>
      {title && <Title>{title}</Title>}
      <SearchInput value={searchQuery} onChange={onSearchQueryChange} />
      <ItemsContainer>
        {isLoading && (
          <SpinnerContainer justifyContent="center" alignItems="center">
            <Spinner size="small" />
          </SpinnerContainer>
        )}
        <ApiErrorNotification error={error} />
        {!isLoading &&
          !error &&
          (items.length > 0 ? (
            <FilterItems
              items={items}
              filterItems={filterItems}
              onChange={onChange}
              openAllCountries={Boolean(searchQuery && searchQuery.length > 0)}
            />
          ) : (
            <StyledEmpty image={<EmptyIcon.FileEmpty />} title={emptyTitle} />
          ))}
      </ItemsContainer>
    </>
  );
};
